import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StoreService {

  constructor() { }
  public isProfileUpdate=new Subject<boolean>();
  markProfileUpdate(isUpdate:boolean){
    this.isProfileUpdate.next(isUpdate);
  }
isProfileUpdated(){
  return  this.isProfileUpdate;
}
}
